import loaded from "@/scripts/helpers/loaded.js";

loaded(() => {
    // The CSS selector of the element we are waiting for
    const selector = ".search__input";

    // First, check if the element already exists on the page
    if (document.querySelector(selector)) {
        console.log("Element found immediately, dispatching event.");
        window.dispatchEvent(new CustomEvent('bind-search-input'));

        return; // Stop the script if the element is already here
    }

    // If the element doesn't exist yet, create an observer to watch for it
    const observer = new MutationObserver((mutations, obs) => {
        // Check if the element has been added to the page
        const element = document.querySelector(selector);
        if (!element) {
            return;
        }

        console.log("Element was added dynamically, dispatching event.");
        window.dispatchEvent(new CustomEvent('bind-search-input'));

        // Stop observing once the element is found to save resources
        obs.disconnect();
    });

    // Start observing the entire document for changes
    observer.observe(document.body, {
        childList: true,  // Watch for nodes being added or removed
        subtree: true     // Watch all descendants of the body
    });
});
